import { TableTextStyles } from 'ag-common-lib/lib/template-builder/table-text-styles';
import { DEFAULT_EMAIL_TABLE_STYLE, DEFAULT_TABLE_STYLES, TableColorScheme, TableStylePreset } from 'ag-common-lib/lib';

export class TableWidgetData {
  title: string = '';
  textStyles?: TableTextStyles;
  selectedStyle: TableStylePreset = DEFAULT_EMAIL_TABLE_STYLE;
  customColorScheme: TableColorScheme = {
    header: '',
    color1: '',
    color2: '',
  };

  get currentColorScheme(): TableColorScheme {
    return this.selectedStyle === TableStylePreset.Custom
      ? this.customColorScheme
      : DEFAULT_TABLE_STYLES[this.selectedStyle];
  }
}
